import Vue from 'vue'
import Vuex from 'vuex'
import { isWeixin } from '@/utils/userAgent'
import { getAccess, findLimit } from '@/service'
import { concatURI } from '@/utils/common'
import { getJson } from '../service'
import { axios } from '@/service/config'
Vue.use(Vuex)
import {
    getMemberInfo,
    getBookmarks,
    getMembershipLevelSettings,
    checkMember
} from '@/service/member'

export default new Vuex.Store({
    state: {
        memberInfo: {
            loading: true
        },
        userInfo: {},
        bookMarks: null,
        bookMarksLoading: false,
        levelSettings: [],
        access: null,
        active: false,
        fileData: {}
    },
    mutations: {},
    actions: {
        async checkAccess({ state, dispatch }, { redirect } = {}) {
            if (state.access != null) return state.access
            let isValid = false,
                freeLogin = false
            let { detail } = await findLimit()
            if (!(detail && Object.keys(detail).length)) {
                detail = {
                    wechatLimit: 'userinfo',
                    notWechatLimit: 'userinfo'
                }
            }
            if (isWeixin()) {
                switch (detail.wechatLimit) {
                    case 'userinfo':
                        window.cw('login_scope', 'snsapi_userinfo')
                        break
                    case 'base':
                        window.cw('login_scope', 'snsapi_base')
                        break
                    case 'nothing':
                        freeLogin = true
                }
            } else {
                switch (detail.notWechatLimit) {
                    case 'userinfo':
                        window.cw('login_scope', 'snsapi_userinfo')

                        window.cw('allowScanLogin', 1)
                        break
                    case 'base':
                        window.cw('login_scope', 'snsapi_base')
                        break
                    case 'nothing':
                        freeLogin = true
                }
            }
            if (freeLogin) {
                isValid = true
            } else {
                await dispatch('getUserInfo')
                const data = await getAccess()
                const redirectTo = redirect || window.location.href
                if (data.code == 200) {
                    isValid = true
                    // 通过
                } else if (data.code == 302) {
                    // 需要填表 redirect
                    const url = concatURI(data.redirect, [
                        { key: 'redirect', val: redirectTo }
                    ])
                    window.location.replace(url)
                } else if (data.code == 306) {
                    // 需要关注 mpQrCode
                } else if (data.code == 403) {
                    // 需要成为会员
                    const { VUE_APP_FORM, VUE_APP_MEMBER_FORMID } = window.env
                    const redirect = VUE_APP_FORM + VUE_APP_MEMBER_FORMID
                    if (redirect) {
                        const url = concatURI(redirect, [
                            { key: 'redirect', val: redirectTo }
                        ])
                        window.location.replace(url)
                    }
                } else {
                    // 黑名单...
                }
            }
            return (state.access = isValid)
        },
        getUserInfo({ state }, autoLogin = true) {
            return new Promise(async (resolve, reject) => {
                if (state.userInfo.openid) {
                    return resolve(state.userInfo)
                }
                window.cw(
                    'info',
                    info => {
                        state.userInfo = info
                        resolve(info)
                    },
                    () => {
                        if (autoLogin) {
                            window.cw('login')
                        }
                    }
                )
            })
        },
        setInfo({ dispatch }) {
            return Promise.all([
                dispatch('getUserInfo'),
                dispatch('getMemberInfo'),
                dispatch('getBookmarks')
            ])
        },
        async getSignatureUrl({ state }, file) {
            let url
            if (/download\.(cloud|beta)\.custouch\.com/.test(file)) {
                url = await axios(file + '?view=2')
            } else {
                url = file
            }
            return url
        },
        async getJson({ state, dispatch }, file) {
            const fileName = file.slice(file.lastIndexOf('/') + 1)
            if (!state.fileData[fileName]) {
                const { VUE_APP_DATA, VUE_APP_DATA_BASE } = window.env
                let url
                if (VUE_APP_DATA_BASE) {
                    url = VUE_APP_DATA_BASE + file
                } else {
                    url = file
                }
                if (/^(https?:)?\/\//.test(url)) {
                    url = await dispatch('getSignatureUrl', url)
                } else {
                    if (VUE_APP_DATA) {
                        url = VUE_APP_DATA
                    } else {
                        throw Error('文件格式错误或缺少必要的文件配置')
                    }
                    url += file
                    if (!url.endsWith('.json')) {
                        url += 'json'
                    }
                }
                const data = await getJson(url)
                if (data) {
                    state.fileData[fileName] = data
                }
            }
            return JSON.parse(JSON.stringify(state.fileData[fileName]))
        },
        async checkMember() {
            const startTime = Date.now()
            while (Date.now() - startTime <= 350) {
                if (await checkMember()) {
                    return true
                }
            }
            throw Error('not member')
        },
        async getMemberInfo({ state, dispatch }) {
            try {
                await dispatch('checkMember')
                const memberInfo = await getMemberInfo()
                // 预填充一些关键字段
                if (!memberInfo.personName) {
                    memberInfo.personName = {}
                }
                memberInfo.address = Object.assign(
                    {
                        country: '',
                        province: '',
                        city: '',
                        district: '',
                        details: ''
                    },
                    memberInfo.address
                )
                state.memberInfo = Object.assign(memberInfo, { loading: false })
                return state.memberInfo
            } catch (error) {
                state.memberInfo = { loading: false }
            }
        },
        async getBookmarks({ state }, force = false) {
            try {
                if (force || !state.bookMarks || state.bookMarks.length === 0) {
                    if (state.bookMarks) {
                        state.bookMarksLoading = false
                    } else {
                        state.bookMarksLoading = true
                    }
                    state.bookMarks = (await getBookmarks()).data
                }
                return state.bookMarks
            } finally {
                state.bookMarksLoading = false
            }
        },
        // 获取申请表单
        async getLevelSettings({ state }, level) {
            const settings = await getMembershipLevelSettings()
            state.levelSettings = settings.map(
                item => item.memberApplicationSetting
            )
            if (level != null) {
                const currentLevel = state.levelSettings[level - 1]
                if (currentLevel && currentLevel.formIds[0]) {
                    return {
                        formId: currentLevel.formIds[0],
                        levelName: currentLevel.membershipLevel.levelName
                    }
                }
                return null
            }
            state.levelSettings.forEach(item => {
                if (item.formIds.length > 0) {
                    return {
                        formId: item.formIds[0],
                        levelName: item.membershipLevel.levelName
                    }
                }
            })
            return null
        }
    }
})
